// ABOUTME: Types for the TUC configs audit log page; mirrors GET /api/tuc-configs/audit-logs (HCP-112400).

export type AuditAction = 'created' | 'updated' | 'deleted'

export type AuditReason = 'reverted' | 'countryDeleted'

export interface AuditLogRecord {
  id: string
  transactionId: string
  traceId: string | null
  entityType: string
  entityId: string
  scopeId: string | null
  countryId: string | null
  businessLine: string | null
  action: AuditAction
  reason: AuditReason | null
  oldValues: Record<string, unknown> | null
  newValues: Record<string, unknown> | null
  changedFields: string[]
  performedBy: string
  performedAt: string
}

export interface AuditLogPage {
  items: AuditLogRecord[]
  totalCount: number
  page: number
  pageSize: number
}

/** Optional filters; `from`/`to` are ISO timestamps. */
export interface AuditLogFilters {
  countryId?: string
  businessLine?: string
  entityType?: string
  action?: AuditAction
  performedBy?: string
  from?: string
  to?: string
}

export const AUDIT_ACTIONS: AuditAction[] = ['created', 'updated', 'deleted']

/** Entity class names recorded by the backend (`IAuditable` entities). */
export const AUDITED_ENTITY_TYPES = [
  'Scope',
  'DeliveryWindow',
  'LoadSpacing',
  'TimeOnJobSite',
  'Spacing',
  'FlowRate',
  'OperationalHours',
  'OrderCancellationLeadTime',
  'OrderChangeLeadTime',
  'OrderIntakeLeadTime',
  'OverbookingAllowance',
  'PumpConfiguration',
  'QuantityConfiguration',
  'Retarder',
  'SlotManagementLeadTime',
  'TrucksConfiguration',
  'UnloadingMethod',
] as const

export const AUDIT_LOG_DEFAULT_PAGE_SIZE = 50
